export const SET_HRMS55X_INDEX_DISP = 'SET_HRMS55X_INDEX_DISP'
export const GET_HRMS55X_INDEX_DISP = 'GET_HRMS55X_INDEX_DISP'
export const SET_HRMS55X_COLUMNS = 'SET_HRMS55X_COLUMNS'
export const GET_HRMS55X_COLUMNS = 'GET_HRMS55X_COLUMNS'
export const SET_HRMS55X_LABELS = 'SET_HRMS55X_LABELS'
export const GET_HRMS55X_LABELS = 'GET_HRMS55X_LABELS'
export const RECEIVED_HRMS55X_COLUMNS_LABELS = 'RECEIVED_HRMS55X_COLUMNS_LABELS'
export const SET_HRMS55X_INDEX = 'SET_HRMS55X_INDEX'
export const GET_HRMS55X_INDEX = 'GET_HRMS55X_INDEX'
export const RECEIVED_HRMS55X_INDEX = 'RECEIVED_HRMS55X_INDEX'
export const RECEIVED_HRMS55X2_INDEX = 'RECEIVED_HRMS55X2_INDEX'



// WEBPACK FOOTER //
// ./src/store/modules/hrms55x/mutation-types.js